<template lang="pug">
  v-select(
    :value="value"
    :items="TYPES_LIST"
    item-value="id"
    item-text="name"
    label="Тип поставщика"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
  )
</template>

<script>
const TYPES_LIST = [{ id: 1, name: 'Образовательная организация' }, { id: 2, name: 'Организация, не являющаяся образовательной организацией' }, { id: 3, name: 'Индивидуальный предприниматель, оказывающий услуги с наймом работников' }, { id: 4, name: 'Индивидуальный предприниматель, оказывающий услуги без найма работников' }];

export default {
  name: 'OrganizationTypeSelect',
  props: {
    value: { type: Number, default: null },
  },
  data: () => ({
    TYPES_LIST,
  }),
};
</script>
